export default __webpack_public_path__ + "static/mobileWireframe-4ad4bbaf2d4402a9ab098325ff8628a8.jpg";